import FSTable from './FSTable';
require('./FSTable.scss');

export default FSTable;